import React from "react";
import { useEvent } from "../../../context/EventContext";

// This function component retrieves and displays the event organizer's name from the event data, if available.
const OraganizerInfo = () => {
  const { formData } = useEvent();

  return (
    <>
      {formData.organized_by && (
        <div className="Organize-info">
          <p>Organized By: {formData.organized_by}</p>
        </div>
      )}
    </>
  );
};

export default OraganizerInfo;
